'use client';

import { useSidebar } from '@/app/context/SidebarContext';
import { ReactNode, useEffect } from 'react';

export default function MainContent({ children }: { children: ReactNode }) {
  const { collapsed } = useSidebar();

  // Flag consumed by the pre-hydration legacy-browser banner (app/layout.tsx).
  // Once hydration completes, runtime errors flow through ErrorBoundary instead
  // of being misread as "browser too old".
  useEffect(() => {
    (window as unknown as { __mcwtHydrated?: boolean }).__mcwtHydrated = true;
  }, []);

  return (
    <div
      className={`flex-1 min-w-0 bg-zinc-950 min-h-svh flex flex-col transition-[margin-left] duration-300 ease-drawer motion-reduce:transition-none ml-0 ${
        collapsed ? 'lg:ml-16' : 'lg:ml-64'
      }`}
    >
      {children}
    </div>
  );
}
